
import { VMenu } from "vuetify/lib";

export default VMenu.extend({});
